import { useState } from 'react'

import { shipmentStatuses, useFetch } from '@reveni-io/reveni-ui'

import { isTrackingParcel } from '@/parcels/helpers/helpers'
import parcelServices from '@/parcels/services/services'

const useParcelOutboundOriginLocation = ({ storeId, parcelId, refetchParcel, setToastInfo, parcel }) => {
  const { fetchData, loading } = useFetch(parcelServices.editParcel, { doInitialRequest: false })
  const [showEditOutboundOriginLocationModal, setShowEditOutboundOriginLocationModal] = useState(false)

  const openEditOutboundOriginLocationModal = () => {
    setShowEditOutboundOriginLocationModal(true)
  }

  const closeEditOutboundOriginLocationModal = () => {
    setShowEditOutboundOriginLocationModal(false)
  }

  const onEditOutboundOriginLocation = async location => {
    const payload = { sender_location: location?.id }

    try {
      await fetchData({ storeId, parcelId, payload })
      closeEditOutboundOriginLocationModal()
      refetchParcel()
    } catch (error) {
      setToastInfo({ show: true, type: 'error', message: error.message })
    }
  }

  const allowEditOutboundOriginLocation =
    !isTrackingParcel(parcel) &&
    [shipmentStatuses.requested, shipmentStatuses.packed, shipmentStatuses.ready].includes(parcel?.status)

  return {
    showEditOutboundOriginLocationModal,
    openEditOutboundOriginLocationModal,
    closeEditOutboundOriginLocationModal,
    onEditOutboundOriginLocation,
    editingOutboundOriginLocation: loading,
    allowEditOutboundOriginLocation,
  }
}

export default useParcelOutboundOriginLocation
